module.exports = __webpack_public_path__ + "img/rejected.5c11e736.png";